import { type Common } from './common.js';
import type * as ProviderTeam from './models/providerTeam.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    args: {
      providerUserId?: string;
      practiceId?: string;
    } = {}
  ): Promise<ProviderTeam.ProviderTeam[]> {
    const url = this.common.constructPath(`/provider-teams`, args);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ProviderTeam.ProviderTeam> {
    const url = this.common.constructPath(`/provider-teams/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: ProviderTeam.CreateValues): Promise<ProviderTeam.ProviderTeam> {
    const url = this.common.constructPath(`/provider-teams`);
    return await this.common.postJSON(url, values);
  }
}
